import { TicketRepository } from '../repositories/TicketRepository'

export function CreateAreaCase(ticketRepository: TicketRepository) {
  return async function ({ data }) {
    return await ticketRepository.createArea({ data })
  }
}
